import { render, staticRenderFns } from "./StaffScheduleUpdate.vue?vue&type=template&id=a96340ae&scoped=true&"
import script from "./StaffScheduleUpdate.vue?vue&type=script&lang=js&"
export * from "./StaffScheduleUpdate.vue?vue&type=script&lang=js&"
import style0 from "./StaffScheduleUpdate.vue?vue&type=style&index=0&id=a96340ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96340ae",
  null
  
)

export default component.exports